import {useLocation, Link} from "react-router-dom";

export default function ResponsiveNavLink({className = '', children, ...props }) {
    const location = useLocation();
    const active = location.pathname === props.to;
    return (
        <Link
            {...props}
            className={`w-full flex items-start ps-3 pe-4 py-2 border-l-4 ${
                active
                    ? 'border-blue-400 text-white focus:text-white focus:bg-indigo-100 focus:border-indigo-700'
                    : 'border-transparent text-white hover:text-gray-500 hover:bg-gray-50 hover:border-gray-300 focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300'
            } text-base font-medium focus:outline-none transition duration-150 ease-in-out ${className}`}
        >
            {children}
        </Link>
    );
}
